import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { OfferResponse } from './types/offerResponse';
import { OrderStatusResponse } from './types/orderStatusResponse';

export function requestOffers(signal?: AbortSignal): AxiosPromise<OfferResponse[]> {
    return libApiInstance.get(`/orders/offers`, { signal });
}

export function requestOfferByKey(
    offerKey: string,
    signal?: AbortSignal,
): AxiosPromise<OfferResponse> {
    return libApiInstance.get(`/orders/offers/${offerKey}`, { signal });
}

export function requestOrderStatus(
    sessionId: string,
    signal?: AbortSignal,
): AxiosPromise<OrderStatusResponse> {
    return libApiInstance.get(`/orders/status/${sessionId}`, { signal });
}
